import React from 'react';
import mergeWith from 'lodash.mergewith';
import { Text, Heading } from 'theme-ui';
import './style.css';

const gradient = {
  background: (t) => `
    linear-gradient(
      125deg,
      ${t.colors.alpha} 32.5%,
      ${t.colors.alphaDarker} 50.5%)
  `,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

const headingGradientsTypes = [
  'gradient-green',
  'gradient-blue',
  'gradient-purple',
  'gradient-blue-second',
];

const headings = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'h1bold',
  'h1semiBold',
  'h1medium',
  'h1h2',
  'h2compact',
  'h3h2',
  'h2h3'
];

const ContentTextWithHyperlinksSupport = ({ as: CustomComponent, content, children, ...props }) => {
  if (!content || content.length < 1) return null;

  const contentArray = Array.isArray(content) ? content : [content];

  return contentArray.map(({ text, ...contentRest }, index) => {
    if (!text) return null;

    contentRest.mb = contentRest.space;

    const { variant, color, ...mergedProps } = mergeWith(
      {},
      props,
      contentRest,
      (a, b) => (b === null ? a : undefined)
    );

    const isHeading = headings.includes(variant);

    const parseTextWithLinks = (inputText) => {
      const linkRegex = /\[(.*?)\]\((.*?)\)/g;
      const parts = [];
      let lastIndex = 0;
      let match;

      while ((match = linkRegex.exec(inputText)) !== null) {
        if (match.index > lastIndex) {
          parts.push(inputText.slice(lastIndex, match.index));
        }
        parts.push(
          <a
            key={`link-${match.index}`}
            href={match[2]}
            target='_blank'
            rel='noopener noreferrer'
            style={{
              fontWeight: 'bold',
              color: '#142585',
              textDecoration: 'none',
            }}
          >
            {match[1]}
          </a>,
        );
        lastIndex = match.index + match[0].length;
      }

      if (lastIndex < inputText.length) {
        parts.push(inputText.slice(lastIndex));
      }

      return parts;
    };

    const contentWithLinks = parseTextWithLinks(text);

    return isHeading ? (
      <Heading
        key={`item-${index}`}
        variant={variant}
        as={
          ['h1bold', 'h1semiBold', 'h1h2'].includes(variant)
            ? 'h1'
            : ['h3h2'].includes(variant)
            ? 'h3'
            : variant
        }
        color={color}
        className={
          color === 'gradient'
            ? 'heading-gradient'
            : headingGradientsTypes.includes(color)
            ? `header-${color}`
            : ''
        }
        {...mergedProps}
      >
        {children || contentWithLinks || text}
      </Heading>
    ) : (
      <Text
        key={`item-${index}`}
        variant={variant}
        color={color}
        className={
          color === 'gradient'
            ? 'heading-gradient'
            : headingGradientsTypes.includes(color)
            ? `header-${color}`
            : ''
        }
        sx={{ whiteSpace: 'pre-wrap' }}
        {...mergedProps}
      >
        {children || contentWithLinks || text}
      </Text>
    );
  });
};

export default ContentTextWithHyperlinksSupport;
